import React from "react";
import './bureau.css';
import Recaptcha from 'react-recaptcha';
const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Bureau extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nom: "",
            prenom: "",
            numero: "",
            adresse: "",
            code_postal: "",
            ville: "",
            telephone: "",
            email: "",
            numero1: "",
            adresse1: "",
            code_postal1: "",
            ville1: "",
            numero_parcelle: "",
            projet_immobilier: "",
            description: "",
            isLoading: false,
            asLoading: false,
            click: false,
            select: true,
            construction: false,
            compte_email: "",
            mdp_email: "",
            isVerified: false
        }
        this.clickButton1 = this.clickButton1.bind(this);
        this.handleChangeSelect = this.handleChangeSelect.bind(this);
        this.handlerChange = this.handlerChange.bind(this);
        this.handlerChange1 = this.handlerChange1.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmit1 = this.handleSubmit1.bind(this);
    }

    handlerChange(event) {
        console.log(event.target.name);
        switch (event.target.name) {
            case 'Nom':
                this.setState({ nom: event.target.value });
                break;
            case 'Prenom':
                this.setState({ prenom: event.target.value });
                break;
            case 'Numero':
                this.setState({ numero: event.target.value });
                break;
            case 'Adresse':
                this.setState({ adresse: event.target.value });
                break;
            case 'Code_postal':
                this.setState({ code_postal: event.target.value });
                break;
            case 'Ville':
                this.setState({ ville: event.target.value });
                break;
            case 'telephone':
                this.setState({ telephone: event.target.value });
                break;
            case 'email':
                this.setState({ email: event.target.value });
                break;
            case 'Numero1':
                this.setState({ numero1: event.target.value });
                break;
            case 'Adresse1':
                this.setState({ adresse1: event.target.value });
                break;
            case 'Code_postal1':
                this.setState({ code_postal1: event.target.value });
                break;
            case 'Ville1':
                this.setState({ ville1: event.target.value });
                break;
            case 'Numero_parcelle':
                this.setState({ numero_parcelle: event.target.value });
                break;
            case 'description':
                this.setState({ description: event.target.value });
                break;
            default:
                break;
        }
    }

    handlerChange1(event) {
        console.log(event.target.name);
        switch (event.target.name) {
            case 'nom':
                this.setState({ nom: event.target.value });
                break;
            case 'prenom':
                this.setState({ prenom: event.target.value });
                break;
            case 'telephone':
                this.setState({ telephone: event.target.value });
                break;
            case 'email':
                this.setState({ email: event.target.value });
                break;
            case 'description':
                this.setState({ description: event.target.value });
                break;
            default:
                break;
        }
    }

    clickButton1() {
        this.setState({ click: !this.state.click })
    }

    handleChangeSelect(event) {
        if (event.target.value === "email") {
            this.setState({ select: true });
        } else if (event.target.value === "devis") {
            this.setState({ select: false });
        }
    }

    snackbarClose = (event) => {
        this.setState({ snackbaropen: false })
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.isVerified) {
            this.setState({ isLoading: true })
            fetch(SERVER_ADDRESS + '/bureaux/' + this.props.id)
                .then(res => res.json())
                .then(res => {
                    this.setState({
                        compte_email: res[0].compte_email,
                        mdp_email: res[0].mdp_email
                    }, () => {
                        fetch(SERVER_ADDRESS + '/devis',
                            {
                                method: 'POST',
                                headers: new Headers({
                                    'Content-Type': 'application/json'
                                }),
                                body: JSON.stringify(this.state),
                            })
                            .then(res => res.json())
                            .then(
                                res => this.setState({ snackbarmessage: res.message }),
                            )
                            .then(
                                () => this.setState({ isLoading: false })
                            )
                            .then(
                                () => this.setState({ asLoading: true })
                            )
                    })
                })
        }
    }

    handleSubmit1(event) {
        event.preventDefault();
        if (this.state.isVerified) {
            this.setState({ isLoading: true })
            fetch(SERVER_ADDRESS + '/bureaux/' + this.props.id)
                .then(res => res.json())
                .then(res => {
                    this.setState({
                        compte_email: res[0].compte_email,
                        mdp_email: res[0].mdp_email
                    }, () => {
                        fetch(SERVER_ADDRESS + '/email_bureaux',
                            {
                                method: 'POST',
                                headers: new Headers({
                                    'Content-Type': 'application/json'
                                }),
                                body: JSON.stringify(this.state),
                            })
                            .then(res => res.json())
                            .then(
                                res => this.setState({ snackbarmessage: res.message }),
                            )
                            .then(
                                () => this.setState({ isLoading: false })
                            )
                            .then(
                                () => this.setState({ asLoading: true })
                            )
                    })
                })
        }
    }

    checkBoxChange = () => {
        this.setState({ construction: !this.state.construction })
    }

    RecaptchapLoader() {
        console.log('capcha successfully loaded');
    }

    verifyCallback = (response) => {
        console.log(response)
        if (response) {
            this.setState({
                isVerified: true
            })
        }
    }

    expiredCallback = () => {
        this.setState({ isVerified: false })
    }
    render() {
        return (
            <div className="bureau column wi-11">
                <h2 className="title_bureau">{this.props.ville}</h2>
                <div className="ctest2"></div>
                <div className="align_info">
                    <div className="pasdenom">
                        <div className="taille">
                            <div className="info_bureau column">
                                <h3>Horaires :</h3>
                                <div className="espaceh">
                                    <span>Du Lundi au Vendredi</span>
                                    <p>{this.props.heure_debut} <span>-</span> {this.props.heure_pause}</p>
                                    <p>{this.props.heure_reprise} <span>-</span> {this.props.heure_fin}</p>
                                </div>
                            </div>
                            <div className="info_bureau column">
                                <h3>Email :</h3>
                                <div className="espace">
                                    <p>{this.props.email}</p>
                                </div>
                            </div>
                        </div>
                        <div className="taille column">
                            <div className="info_bureau column">
                                <h3>Téléphone :</h3>
                                <div className="espace">
                                    <p>{this.props.telephone}</p>
                                </div>
                            </div>
                            <div className="info_bureau column">
                                <h3>Fax :</h3>
                                <div className="espace">
                                    <p>{this.props.fax}</p>
                                </div>
                            </div>
                            <div className="info_bureau column">
                                <h3>Adresse :</h3>
                                <div className="espaceh">
                                    <p>{this.props.numero} {this.props.adresse} {this.props.code_postal} {this.props.ville}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <iframe src={this.props.iframe} width="600" height="450" title="laloupe"></iframe>
                    <div className={this.state.click ? "" : "ctest1"}></div>
                    <div className={this.state.click ? "ladivoff" : "ladivdubouton"}>
                        <button onClick={this.clickButton1} style={{ backgroundColor: this.state.click ? "#dc3545" : "#1a7db6" }} className="lebouton">{this.state.click ? 'Fermer' : 'Contacter'}</button>
                    </div>


                    {this.state.click ?
                        <div className='display column'>
                            <div className="typeform marg column">
                                <h3>Type de formulaire :</h3>
                                <select className="select-button" onChange={this.handleChangeSelect} name="type">
                                    <option value="email">Email</option>
                                    <option value="devis">Devis</option>
                                </select>
                            </div>
                            {this.state.select ?
                                <div className="formulaire">
                                    <form className="container" onSubmit={this.handleSubmit1}>
                                        <div className="max-wi">
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Nom</div>
                                                    </div>
                                                    <input type="text" name="nom" placeholder="Nom" className="form-control" onChange={this.handlerChange1} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Prénom</div>
                                                    </div>
                                                    <input type="text" name="prenom" placeholder="Prénom" className="form-control" onChange={this.handlerChange1} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Téléphone</div>
                                                    </div>
                                                    <input type="text" name="telephone" placeholder="Téléphone" className="form-control" onChange={this.handlerChange1} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Email</div>
                                                    </div>
                                                    <input type="text" name="email" placeholder="Email" className="form-control" onChange={this.handlerChange1} />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="message-div input-group-text">Message</div>
                                                <textarea name="description" className="message-div2 form-control" placeholder="Description de votre message" rows="3" onChange={this.handlerChange1}></textarea>
                                            </div>
                                            <div className="captcha row justify-content-center captchaspe">
                                                <Recaptcha
                                                    sitekey="6LcjTcQUAAAAAEa4n2XWWANTPERrWZQBO071ZJrA"
                                                    render="explicit"
                                                    hl="fr"
                                                    onloadCallback={this.RecaptchapLoader}
                                                    verifyCallback={this.verifyCallback}
                                                    expiredCallback={this.expiredCallback}
                                                />
                                            </div>
                                        </div>
                                        {this.state.asLoading ?
                                            <div
                                                style={{
                                                    marginTop: "35px"
                                                }}
                                                className="alert alert-success" role="alert">
                                                {this.state.snackbarmessage}
                                            </div>
                                            :
                                            ""
                                        }

                                        <div className={this.state.click ? "ctest1" : ""}></div>

                                        <div className={this.state.click ? "ladivdubouton" : ""}>
                                            <button type="submit" className="leboutondenvoi">Envoyer</button>
                                        </div>
                                    </form>
                                </div>
                                :
                                <div className="formulaire">
                                    <form className="container" onSubmit={this.handleSubmit}>
                                        <div className="max-wi">
                                            <div className="group-int"><strong>Civilité client</strong></div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Nom</div>
                                                    </div>
                                                    <input type="text" name="Nom" placeholder="Nom" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Prenom</div>
                                                    </div>
                                                    <input type="text" name="Prenom" placeholder="Prenom" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Numero</div>
                                                    </div>
                                                    <input type="number" name="Numero" placeholder="Numero" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Adresse</div>
                                                    </div>
                                                    <input type="text" name="Adresse" placeholder="Adresse" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Code postal</div>
                                                    </div>
                                                    <input type="text" name="Code_postal" className="form-control" placeholder="code postal" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Ville</div>
                                                    </div>
                                                    <input type="text" name="Ville" placeholder="Ville" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Telephone</div>
                                                    </div>
                                                    <input type="text" name="telephone" className="form-control" placeholder="numéro de téléphone" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Email</div>
                                                    </div>
                                                    <input type="email" name="email" className="form-control" placeholder="exemple@email.fr" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="group-int adresse-top"><strong>Adresse du projet</strong></div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Numero</div>
                                                    </div>
                                                    <input type="number" name="Numero1" placeholder="Numero" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Adresse</div>
                                                    </div>
                                                    <input type="text" name="Adresse1" placeholder="Adresse" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Code postal</div>
                                                    </div>
                                                    <input type="text" name="Code_postal1" className="form-control" placeholder="code postal" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Ville</div>
                                                    </div>
                                                    <input type="text" name="Ville1" placeholder="Ville" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Numero de la parcelle</div>
                                                    </div>
                                                    <input type="text" name="Numero_parcelle" placeholder="Numero de la parcelle" className="form-control" onChange={this.handlerChange} />
                                                </div>
                                            </div>
                                            <div className="form-group center-input">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text">Avez vous un projet de construction ?</div>
                                                    </div>
                                                    <input type="checkbox" name="Projet" className="form-control" onChange={this.checkBoxChange} />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group-text">Description de votre projet</div>
                                                <textarea name="Description" className="form-control" id="exampleFormControlTextarea1" placeholder="Description de votre projet" rows="3" onChange={this.handlerChange}></textarea>
                                            </div>
                                            <div className="captcha row justify-content-center captchaspe">
                                                <Recaptcha
                                                    sitekey="6LcjTcQUAAAAAEa4n2XWWANTPERrWZQBO071ZJrA"
                                                    render="explicit"
                                                    hl="fr"
                                                    onloadCallback={this.RecaptchapLoader}
                                                    verifyCallback={this.verifyCallback}
                                                    expiredCallback={this.expiredCallback}
                                                />
                                            </div>
                                            {this.state.asLoading ?
                                                <div
                                                    style={{
                                                        marginTop: "35px"
                                                    }}
                                                    className="alert alert-success" role="alert">
                                                    {this.state.snackbarmessage}
                                                </div>
                                                :
                                                ""
                                            }
                                        </div>

                                        <div className={this.state.click ? "ctest1" : ""}></div>

                                        <div className={this.state.click ? "ladivdubouton" : ""}>
                                            <button type="submit" className="leboutondenvoi">Envoyer</button>
                                        </div>
                                    </form>
                                </div>
                            }
                        </div>
                        :
                        ""
                    }
                </div>
            </div>
        )
    }
}

export default Bureau;
